import { render, staticRenderFns } from "./appliedQuota.vue?vue&type=template&id=03feec98&scoped=true"
import script from "./appliedQuota.vue?vue&type=script&lang=js"
export * from "./appliedQuota.vue?vue&type=script&lang=js"
import style0 from "./appliedQuota.vue?vue&type=style&index=0&id=03feec98&prod&lang=css"
import style1 from "./appliedQuota.vue?vue&type=style&index=1&id=03feec98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03feec98",
  null
  
)

export default component.exports